import { render } from "./QuestionPage.vue?vue&type=template&id=1e95c938&scoped=true"
import script from "./QuestionPage.vue?vue&type=script&lang=js"
export * from "./QuestionPage.vue?vue&type=script&lang=js"

import "./QuestionPage.vue?vue&type=style&index=0&id=1e95c938&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e95c938"]])

export default __exports__